import {PullRequestStateIcons} from '@github-ui/issue-pr-state/Icons'

/**
 * Tooltip label shown when a pull request's display state cannot be resolved to a known state icon.
 */
export const PR_STATE_FALLBACK_TOOLTIP_LABEL = 'Pull request'

/**
 * Human-readable tooltip labels for each pull request state icon, keyed by the
 * `PullRequestStateIcons` state. Shared across the pulls list and inbox list items.
 */
export const PR_STATE_TOOLTIP_LABELS: Record<keyof typeof PullRequestStateIcons, string> = {
  OPEN: 'Open pull request',
  CLOSED: 'Closed pull request',
  MERGED: 'Merged pull request',
  DRAFT: 'Draft pull request',
  IN_MERGE_QUEUE: 'Pull request in merge queue',
  QUEUED: 'Queued pull request',
  ARCHIVED: 'Archived pull request',
}
